import React from 'react';
import {SENTRY_ERROR_TESTING_MODE} from '../../config/App';
import './VersionTag.css';

function VersionTag({version}) {
    const handleClick = () => {
        if (SENTRY_ERROR_TESTING_MODE) {
            const randomMessage = Math.random().toString(36).substring(2);
            throw new Error(randomMessage);
        }
    };

    const getEnvironmentKey = () => {
        const hostname = window.location.hostname;
        if (hostname === 'localhost') return 'LOC';
        if (hostname.startsWith('kiosk-3d971--development-')) return 'DEV';
        if (hostname.startsWith('kiosk-3d971--staging-')) return 'STA';
        if (hostname.startsWith('kiosk-3d971--preproduction-')) return 'PRE';
        if (hostname === 'kiosco.motiondisplays.com' || hostname === 'kiosk-3d971.web.app' || hostname === 'kiosk-3d971.firebaseapp.com') return 'PRO';
        return 'UNK';
    };

    return (
        <div className='version-tag' onClick={handleClick}>v{version}-{getEnvironmentKey()}</div>
    );
}

export default VersionTag;